import { render, staticRenderFns } from "./style_collection_new_updated.vue?vue&type=template&id=87bd14ca"
import script from "./style_collection_new_updated.vue?vue&type=script&lang=js"
export * from "./style_collection_new_updated.vue?vue&type=script&lang=js"
import style0 from "./style_collection_new_updated.vue?vue&type=style&index=0&id=87bd14ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports